import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

const TypeRhythm = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
}) => {
  const { t } = useTranslation();

  function handleChange(e) {
    updateValidationOnChange(field.key, e.target.value);
  }

  return (
    <FormControl fullWidth>
      <InputLabel id={"type-preset-var-type-" + field.key}>
        {field.label}
      </InputLabel>
      <Select
        labelId={"type-preset-var-type-" + field.key}
        value={dataCollection[field.key] ? dataCollection[field.key] : 1}
        label={field.label}
        onChange={handleChange}
      >
        <MenuItem value={1}>{t("Monthly")}</MenuItem>
        <MenuItem value={3}>{t("Quarterly")}</MenuItem>
        <MenuItem value={6}>{t("Semiannual")}</MenuItem>
        <MenuItem value={12}>{t("Annual")}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default TypeRhythm;
